import React, { FC } from 'react';

import { Stack, Button } from '@sparky';
import { StackProps } from '@sparky/types';

interface Props extends Partial<Pick<StackProps, 'alignY' | 'alignX'>> {
  isLoading?: boolean;
}

export const NextButton: FC<React.PropsWithChildren<Props>> = ({ isLoading, alignY, alignX, children }) => (
  <Stack direction={{ initial: 'column', md: 'row' }} alignY={alignY} alignX={alignX}>
    <Button type="submit" isLoading={isLoading}>
      {children}
    </Button>
  </Stack>
);
